/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

type GetPfmLocationFromIntcmpParams = {
  intcmp: string | string[] | undefined;
  previousPageURL: string | null | undefined;
  categoryPageType: string | null | undefined;
};

export function getPfmLocationFromIntcmp({
  intcmp,
  previousPageURL,
  categoryPageType,
}: GetPfmLocationFromIntcmpParams): string | undefined {
  const intcmpValue = Array.isArray(intcmp) ? intcmp.filter(Boolean)[0] : intcmp;
  const intcmpCode = typeof intcmpValue === 'string' ? intcmpValue.split(':')[0] : '';
  const prevBlogPage = previousPageURL?.includes('/diy');

  return prevBlogPage
    ? 'Blogs Page'
    : intcmpCode === 'HOM'
      ? 'Home Page'
      : intcmpCode === 'LAP'
        ? 'Landing Page'
        : intcmpCode === 'DLS'
          ? 'Deals Landing Page'
          : intcmpCode === 'SHF'
            ? 'Shelf Page'
            : intcmpCode === 'CAT'
              ? categoryPageType === 'catalog_subcategory'
                ? 'Subcategory Page'
                : 'Category Page'
              : undefined;
}
